export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastV2/theme/components/scorecard/MetricsLabels/index.js